import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'

const baseURL = process.env.NODE_ENV === 'development'
  ? 'http://192.168.88.115:680/hkapi'   // 对应原来的 env.baseUrl
  : 'https://api.manybo.com/index.php/hkapi'

const service = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    Device: 'web',
    'App-version': '2.1.30',
    'Api-version': 'v2'
  }
})

service.interceptors.request.use(config => {
  config.headers['App-package'] = 'com.manybo.user'
  if (store.getters.access) {
    config.headers['Authorization'] = 'Bearer ' + store.getters.access
  }
  return config
}, error => Promise.reject(error))

service.interceptors.response.use(
  async ({ data: resp, status: statusCode, config }) => {
    if (statusCode !== 200) return Promise.reject(resp)
    const { status, data, msg } = resp

    switch (status) {
      case 1000:
        location.reload(true)
        return
      case -1:
      case -1009:
        store.dispatch('user/LogOut')
        return Promise.reject(msg)
      case -1003:
        try {
          const token = await service.post('/Token/refresh', {
            token: store.getters.refresh
          })
          if (!token) {
            store.dispatch('user/LogOut')
            return Promise.reject(msg)
          }
          await store.dispatch('user/Refresh', token)
          return service(config)
        } catch (e) {
          return Promise.reject(msg)
        }
      case -2000:
        router.push('/activation')
        return Promise.reject(msg)
      case 1:
        return data
      default:
        Message.error(msg)
        return Promise.reject('error')
    }
  },
  error => {
    Message.error(error.message)
    return Promise.reject(error)
  }
)

export default service